import React, { useEffect, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import axios from "axios";

const FeaturesServices = ({ textAlign, serviceStyle }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(
          "https://new.whatson.agency/wp-json/wp/v2/services-uk?_fields=acf,title,id&acf_format=standard&include=766,764,763"
        );
        console.log(response.data); // Inspect the API response
        // Reorder to the exact sequence 766, 764, 763
        const desiredOrder = [766, 764, 763];
        const orderedServices = desiredOrder.map(id => response.data.find(service => service.id === id)).filter(Boolean);
        setServices(orderedServices);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error.response?.data?.message || error.message}</p>;
  }

  return (
    <div className="row row--15 service-wrapper" role="list" aria-label="Service items">
      <h2 className="sr-only">Available services</h2>
      {services.map((service) => (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={service.id} role="listitem">
          <ScrollAnimation
            animateIn="fadeInUp"
            animateOut="fadeInOut"
            animateOnce={true}
          >
            <article className={`service ${serviceStyle} ${textAlign}`} aria-label={`Service: ${service.title?.rendered || 'Service'}`}>
              <div className="icon">
                {service.acf?.service_image && (
                  <img
                    src={
                      service.acf.service_image.startsWith("http")
                        ? service.acf.service_image
                        : `https://new.whatson.agency${service.acf.service_image}`
                    }
                    alt={`${service.title?.rendered || 'Service'} icon`}
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                )}
              </div>
              <div className="content">
                <h3 className="title w-600">
                  {service.title?.rendered || "No Title"}
                </h3>
                <p
                  className="description b1 color-gray mb--0"
                  dangerouslySetInnerHTML={{
                    __html:
                      service.acf?.service_summary || "No summary available",
                  }}
                ></p>
                {service.acf?.button_url && (
                  <a
                    className="btn-default btn-small mt--15"
                    href={service.acf.button_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Learn more about ${service.title?.rendered || 'this service'}`}
                  >
                    See More
                  </a>
                )}
              </div>
            </article>
          </ScrollAnimation>
        </div>
      ))}
    </div>
  );
};

export default FeaturesServices;
